export default __webpack_public_path__ + "static/media/09_chart 2.d3deadae.gif";